<template>
  <v-dialog
    v-model="addUserDialogisShown"
    width="500"
  >
    <v-container class="ma-0 pa-0">
      <v-card>
        <v-card-title
          class="headline grey lighten-2"
          primary-title
        >
          Add a {{ type }}
        </v-card-title>
        <v-form
          ref="form"
          v-model="valid"
          @submit.prevent
        >
          <v-card-text>
            <v-text-field
              color="orange"
              v-model="email"
              label="Email"
              clearable
              :rules="emailRules"
              @keydown.enter="submit"
              lazy-validation
              autocomplete="new-password"
              ref="email"
              autofocus
            />
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-row justify="end" class="ma-0 pa-0">
              <v-btn
                color="orange"
                text
                @click="addUserDialogisShown = false"
              >
                Cancel
              </v-btn>
              <v-btn
                color="orange"
                text
                @click="submit"
              >
                Add
              </v-btn>
            </v-row>
          </v-card-actions>
        </v-form>
      </v-card>
    </v-container>
  </v-dialog>
</template>

<script>
import { mapState, mapActions } from 'vuex'

export default {
  name: 'AddUserModal',

  props: ['type', 'isShown'],

  data: () => ({
    valid: false,
    email: '',
    emailRules: [
      (v) => !!v || 'E-mail is required',
      (v) => /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(v) || 'E-mail must be valid'
    ]
  }),

  async created () {
    await this.requestAllOrganizations()
    this.organization = JSON.parse(JSON.stringify(this.clientOrganizationInfo))
  },

  methods: {
    ...mapActions(['requestInviteUser', 'requestAllOrganizations', 'requestOrganization']),

    submit () {
      if (this.$refs.form.validate()) {
        this.handleAddUser()
        this.$refs.form.reset()
        this.addUserDialogisShown = false
      }
    },

    async handleAddUser () {
      this.$emit('add-user', this.email)
    }
  },

  computed: {
    ...mapState({
      challenges: state => state.challenge.challenges,
      organizations: state => state.organization.organizations,
      clientOrganizationInfo: state => state.organization.clientOrganizationInfo
    }),

    challenge () {
      var challengeId = this.$route.params.id
      return this.challenges.find(c => c.id === challengeId)
    },

    addUserDialogisShown: {
      get () {
        // if (this.isShown) {
        //   this.$nextTick(() => {
        //     console.log('FOCUSING')
        //     console.log(this.$refs.email.focus)
        //     this.$refs.email.focus()
        //   })
        // }
        return this.isShown
      },
      set () {
        this.$emit('update:isShown')
      }
    }
  }

  // watch: {
  //   isShown: function (isShown) {
  //     if (isShown) {
  //       this.$nextTick(() => {
  //         console.log('FOCUSING')
  //         this.$refs.email.focus()
  //       })
  //     }
  //   }
  // }
}
</script>

<style lang="sass" scoped>
.v-settings
  .v-item-group
    cursor: pointer

    &__item
      border-width: 3px
      border-style: solid
      border-color: transparent !important

      &--active
        border-color: #00cae3 !important
</style>
